import env from '~/env'
import storage from '~/foundation/storage/localstorage'
import { BASE_URL } from './keycloack-api.contants'

/**
 * Retrieves the redirect URI.
 *
 * @returns The redirect URI.
 */
export const getRedirectUri = () => `${window.location.origin}${window.location.pathname}`

/**
 * Guarda os query params no localStorage.
 */
export function storeQueryParams() {
  const urlParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlParams.entries())
  storage.set('storedQueryParams', params)
}

/**
 * Limpa os query params do localStorage.
 */
export function clearStoredQueryParams() {
  storage.remove('storedQueryParams')
}

/**
 * Recupera os query params do localStorage.
 */
export function getStoredQueryParams() {
  const storedQueryParams = storage.get<Record<string, string>>('storedQueryParams')
  return storedQueryParams
}

/**
 * Redirects the user to the Keycloak login page.
 */
export function redirect() {
  const redirectUri = getRedirectUri()
  storeQueryParams()
  const url = new URLSearchParams()
  url.append('client_id', env.VITE_KEYCLOAK_CLIENT_ID)
  url.append('redirect_uri', encodeURI(redirectUri))
  url.append('response_type', 'code')
  url.append('scope', 'openid profile email')

  window.location.href = `${BASE_URL}/auth?${url}`
}

/**
 * Clean URL parameters (code and state) from the URL.
 */
export function cleanUrlParams() {
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('session_state')
  url.searchParams.delete('state')
  // restore query params
  const storedQueryParams = getStoredQueryParams()
  for (const key in storedQueryParams)
    url.searchParams.set(key, storedQueryParams[key])

  clearStoredQueryParams()
  // replace the current URL
  window.history.replaceState({}, document.title, url)
}
